module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', _vm._b({}, 'el-col', _vm.$props, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb44050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/col/rtCol.vue
// module id = 1434
// module chunks = 116